// extracted by mini-css-extract-plugin
export default {"header":"Z6Zns__header","headerText":"xhLt___headerText"};